export const extractYouTubeId = (url: string) => {
  const match = url.match(/(?:v=|youtu\.be\/|shorts\/|embed\/|live\/)([A-Za-z0-9_-]{11})/);
  return match?.[1] ?? null;
};
